import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';

/**
 * Assign Roles to User Use Case
 * Assigns multiple roles to a user
 */
export class AssignRolesToUserUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(userId: string, roleIds: string[]): Promise<void> {
        await this.roleRepository.assignRolesToUser(userId, roleIds);
    }
}